import React from 'react';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
const useStyles = makeStyles(() => ({
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '99%',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));
export const GenericCircularProgess = () => {
  const classes = useStyles();
  return (
    <div className={classes.loadingContainer}>
      <CircularProgress data-testid="circular-progress" />
    </div>
  );
};
